import {Component, Input} from "@angular/core";
import {RiskFactor} from "../../../../../../model/lookup-results.model";
import {LookupService} from "../../../../lookup.service";

@Component({
  selector: "admin-lookup-factor-monitoring",
  templateUrl: "./monitoring.component.html",
  styleUrls: ["./monitoring.component.css"]
})
export class AdminLookupFactorMonitoringComponent {

  @Input() factor: RiskFactor

  constructor(
    private singleService: LookupService,
  ) {
  }

}
